<template>
  <div class="centerdiv">
    <h2>辅助功能</h2>
    <el-row>
      <el-col :span="6" class='labright'>从多少号开始（含此大题）</el-col>
      <el-col :span="6" class='lableft'>
        <el-input v-model="startMain"></el-input>
      </el-col>
      <el-col :span="12" class='textleft'>
       <el-button type="primary" @click="addProblemMain" style="width:150px">增加大题号</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="6" class='lableft'>初始化用户到第一题，用户GUID</el-col>
      <el-col :span="6" class='lableft'>
        <el-input v-model="startMain"></el-input>
      </el-col>
      <el-col :span="12" class='lableft'>
       <el-button type="primary" @click="initUser" style="width:150px">初始化</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="2" class='labright'></el-col>
      <el-col :span="9" class='labright'>参考网址：</el-col>
    </el-row>
    <el-row>
      <el-col :span="2" class='labright'></el-col>
      <el-col :span="22" class='labright'>katex公式网址：https://khan.github.io/KaTeX/docs/supported.html</el-col>
    </el-row>
    <el-row>
      <el-col :span="2" class='labright'></el-col>
      <el-col :span="22" class='labright' >内部链接写法：#/answer?title=知识点&guid=...</el-col>
    </el-row>
    <el-row>
      <el-col :span="2" class='labright'></el-col>
      <el-col :span="22" class='labright' >内部pdf链接写法：#/pdf?title=1000个数学难题&url=...</el-col>
    </el-row>
    <el-row>
      <el-col :span="2" class='labright'></el-col>
      <el-col :span="22" class='labright' >外部链接写法：#/outPage?title=欧拉&url=https://baike.baidu.com/...</el-col>
    </el-row>
    <el-row>
      <el-col :span="2" class='labright'></el-col>
      <el-col :span="22" class='labright' >数学绘图网站：www.geogebra.org</el-col>
    </el-row>
    <el-row>
      <el-col :span="2" class='labright'></el-col>
      <el-col :span="22" class='labright' >数学公式生成透明图：http://www.codecogs.com/latex/eqneditor.php</el-col>
    </el-row>
    <el-row>
      <el-col :span="2" class='labright'></el-col>
      <el-col :span="22" class='labright' >查看关卡地内容地址：localhost:8080/#/level?level=2</el-col>
    </el-row>
    <el-row>
      <el-col :span="2" class='labright'></el-col>
      <el-col :span="22" class='labright' >压缩图片网址：https://tinypng.com/ --png用它；https://squoosh.app/  --jpg用它</el-col>
    </el-row>
    <el-row>
      <el-col :span="2" class='labright'></el-col>
      <el-col :span="22" class='labright' >跳转到用户主页：#/userInfo/d6c0a240bd4211e89076535ee3dd7eaf</el-col>
    </el-row>
    <el-row>
      <el-col :span="2" class='labright'></el-col>
      <el-col :span="22" class='labright' >mathWeb中题目访问方法：mathmarch.com/problem/9a8414e016e311f08fa3abd5fe2eb099</el-col>
    </el-row>
    <el-row>
      <el-col :span="2" class='labright'></el-col>
      <el-col :span="22" class='labright' >mathWeb中知识点访问方法：mathmarch.com/knowledge/96fce2203b4d11ee83fff95b5f929ea9</el-col>
    </el-row>
    <el-row>
      <el-col :span="2" class='labright'></el-col>
      <el-col :span="22" class='labright' >题目中加入动画的方法：@@交互演示@@，然后加上阿里OSS下的链接，如：
https://longmathimg.oss-cn-shanghai.aliyuncs.com/animate/assets/12k_pid_6.js，然后在 animateJSNames中输入JS名12k_pid_6，如果有多个，全输入并用逗号分隔。</el-col>
    </el-row>
    
  </div>
</template>


<script>
  import { mapGetters } from 'vuex'
  import { addProblemsMainFromStartMain } from '@/api/api_managerPage.js'

  export default {
    data () {
      return {
        startMain: 0
      }
    },
    computed: {
      ...mapGetters([
        'welcome'
      ])
    },
    created () {

    },
    mounted () {

    },
    methods: {
      showMsg (msg, type = 'warning') {
        this.$notify({
          title: '出题',
          message: msg,
          type: type
        })
      },
      commit () {

      },
      initUser() {

        // todo 初始化用户到第一题
        
      },
      addProblemMain () {
        console.log('----------从 ' + this.startMain + ' 开始向后加1')
        let sm = {}
        sm.startMain = this.startMain
        addProblemsMainFromStartMain(sm)(this.pInfo).then((res) => {
          if (res.data) {
            if (res.data.isOk === true) {
              this.showMsg('加题号成功。', 'info')
            } else {
              this.showMsg('加题号失败。', 'info')
            }
          } else {
            this.showMsg('加题号不成功。', 'info')
          }
        }).catch(err => {
          this.showMsg(`加题号失败2。${err}`)
        })
      }
    }
  }
</script>

<style scoped>
  .centerdiv {
    height: auto;
    text-align: center;
  }

  .labright {
    height: 50px;
    line-height: 40px;
    text-align: left;
    vertical-align: middle;
  }
  .rowheight{
    text-align: left;
    vertical-align: middle;
  }
  .textleft {
    text-align: left;
    height: 30px;
  }

  .lableft {
    text-align: left;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #20a0ff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// managerPage.vue?3cf1ebd7